'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * bouton pour grouper/degrouper suivant une colonne + cache la colonne de groupement quand groupé
 * Il s'agit d'une version simplifiée qui marche dans le contexte du porfeuille de subvention. A méliorer pour généraliser (etat du bouton, colonne affichée, cachée, ...)
 */
ngModule.directive("itSubtotalButton", function (itTableRegistry) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "selectorCtrl",
    template: require("./itSubtotalButton.html"),
    link: function link($scope, $el, $attrs, ctrl) {
      if ($attrs.subtotalGroup) {
        // id de la colonne
        $scope.column = $attrs.subtotalGroup;
      } else {
        console.error("Il manque un attribut subtotal-group à it-subtotal-button");
      }
      if ($attrs.groupLabel) {
        $scope.groupLabel = $attrs.groupLabel;
      } else {
        $scope.groupLabel = "Grouper";
      }
      if ($attrs.ungroupLabel) {
        $scope.ungroupLabel = $attrs.ungroupLabel;
      } else {
        $scope.ungroupLabel = "Dégrouper";
      }

      // initialisé par un watch sur le context
      $scope.group = null;
      $attrs.$observe("tableId", function (tableId) {
        var unwatch = $scope.$watch(function () {
          return itTableRegistry.getController(tableId);
        }, function (tableController) {
          if (!tableController) {
            return;
          }
          unwatch();
          ctrl.setTableController(tableController);
        });
      });
    },
    controller: function controller($scope, xlsMetadataService) {
      var ctrl = this,
        tableCtrl = null;
      ctrl.setTableController = function (_tableCtrl) {
        tableCtrl = _tableCtrl;
        $scope.$watch(function () {
          return tableCtrl.getContext().subtotal;
        }, function (subtotal) {
          if (subtotal == null) {
            $scope.group = false;
          } else {
            $scope.group = subtotal.column === $scope.column;
          }
        }, true);
      };
      function isSortColumn(context, column) {
        return context.sort.column === (_.isNumber(context.sort.column) ? column.index : column.id);
      }
      $scope.click = function (event) {
        if (!tableCtrl) {
          console.error("Pas de table controller disponible ");
        }
        var currentGroup = $scope.group;
        var column = tableCtrl.findColumnByIndexOrId($scope.column);
        tableCtrl.subTotalBy(column.id || column.index);

        // ne stock pas le tri lié au sous total
        tableCtrl.sortBy(column.id || column.index, isSortColumn(tableCtrl.getContext(), column) ? tableCtrl.getContext().sort.desc : false, {
          //  silent:true
          //, noContextUpdate:true
        });

        // on cache la colonne si on est en groupé.
        tableCtrl.toggleColumnVisibility($scope.column, currentGroup);
        tableCtrl.refreshColumnsSizing();
        tableCtrl.refreshContent();

        //$scope.group = !$scope.group;

        // todo - utile ?
        _.delay(function () {
          $scope.$broadcast("$redraw");
          $scope.$apply();
        }, 200);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/components/subtotalButton/itSubtotalButton.js
// module id = 2808
// module chunks = 13